import { useEffect } from 'react';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddPack from './components/AddPack';
import '../../styles/products.scss';

const PackCreate = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Créer un Pack');
  }, [setTitle]);

  return (
    <div className="pack-create-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddPack />
        </Col>
      </Row>
    </div>
  );
};

export default PackCreate;